exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-options-menu{position:relative;width:auto;margin-right:1rem}.content-options-menu:last-child{margin-right:0}.content-options-button{display:inline-block;width:auto;height:2rem;padding-top:.5rem}.content-options-button svg{height:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ContentOptionsMenu/ContentOptionsMenu.scss
// module id = 671
// module chunks = 0